import type { Tool } from './tools';

type Props = {
  tool: Tool;
  accent: string;
};

export function LaunchOverlay({ tool, accent }: Props) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(8,8,14,.78)',
        backdropFilter: 'blur(8px)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 9000,
        animation: 'fadeIn .25s ease both',
      }}
    >
      <div
        style={{
          width: 'min(100%, 420px)',
          background: 'var(--cream)',
          color: 'var(--ink)',
          borderRadius: 14,
          padding: '34px 32px',
          textAlign: 'left',
          boxShadow: '0 30px 90px rgba(0,0,0,.5)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 18 }}>
          <div
            style={{
              width: 54,
              height: 54,
              borderRadius: 12,
              background: 'var(--ink)',
              color: '#fff',
              display: 'grid',
              placeItems: 'center',
              fontWeight: 700,
              fontSize: 24,
              letterSpacing: '-0.02em',
            }}
          >
            {tool.mono}
          </div>
          <div>
            <div style={{ fontSize: 20, fontWeight: 600, letterSpacing: '-0.01em' }}>
              {tool.name}
            </div>
            <div style={{ fontSize: 13, color: 'rgba(14,14,14,.6)' }}>{tool.tagline}</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
          <div
            style={{
              width: 22,
              height: 22,
              borderRadius: '50%',
              border: `2.5px solid ${accent}33`,
              borderTopColor: accent,
              animation: 'spin 1s linear infinite',
            }}
          />
          <span className="mono" style={{ color: 'rgba(14,14,14,.6)' }}>
            Launching {tool.name}…
          </span>
        </div>
      </div>
    </div>
  );
}
